




















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { HmoModule } from '@/store/modules/hmo.module'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import AddHMOModal from '@/views/app/management/payments/components/AddHMOModal.vue'
import DeleteHMOModal from '@/views/app/management/payments/components/DeleteHMOModal.vue'
import CantDeleteHMOModal from '@/views/app/management/payments/components/CantDeleteHMOModal.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import { EUserPermissions, IFacility, IHmo } from '@zunta/configurations'
import Table from '@/components/tables/Table.vue'
import Card from '@/components/Card.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { isSubset, getTooltipListText } from '@/utils/helpers'

@Component({
  components: {
    Card,
    Table,
    Icon,
    AddHMOModal,
    DeleteHMOModal,
    CantDeleteHMOModal
  }
})
export default class ManagementHmos extends Vue {
  hmoModuleInstance: HmoModule = getModule(HmoModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  getTooltipListText: Function = getTooltipListText
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  hmoPreparedForDeletion: number | null = null
  hmoPreparedForDeletionName: string = ''
  hmoPreparedForEdit: any = null
  showAddHMOModal: boolean = false
  showDeleteHmoModal: boolean = false
  showCantDeleteHmoModal: boolean = false
  windowWidth: number = window.innerWidth

  get config (): ITableConfig {
    const config: ITableConfig = {
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      usePagination: true,
      useQuery: true,
      fetchFunction: this.hmoModuleInstance.getHmoList,
      maxHeight: 'calc(100vh - 365px)',
      minHeight: 'calc(100vh - 365px)',
      columns: [
        {
          minWidth: '230px',
          width: 14.28,
          key: 'name',
          searchKey: 'name',
          hasSort: true,
          hasSearch: true,
          label: 'Name',
          type: ETableColumnType.default
        },
        {
          minWidth: '240px',
          width: 14.28,
          key: 'address',
          searchKey: 'address',
          hasSort: true,
          hasSearch: true,
          label: 'Address',
          type: ETableColumnType.default
        },
        {
          minWidth: '160px',
          width: 14.28,
          key: 'city',
          searchKey: 'city',
          hasSort: true,
          hasSearch: true,
          label: 'City',
          type: ETableColumnType.default
        },
        {
          minWidth: '125px',
          width: 14.28,
          key: 'state',
          searchKey: 'state',
          hasSort: true,
          hasSearch: true,
          label: 'State',
          type: ETableColumnType.default
        },
        {
          minWidth: '105px',
          width: 14.28,
          key: 'zip',
          searchKey: 'zip',
          hasSort: true,
          hasSearch: true,
          label: 'Zip',
          type: ETableColumnType.default
        },
        {
          minWidth: '105px',
          width: 14.28,
          key: 'numberOfFacilities',
          searchKey: 'numberOfFacilities',
          hasSort: true,
          hasSearch: true,
          label: '# of Facilities',
          type: ETableColumnType.default
        },
        {
          minWidth: '30px',
          width: 14.28,
          class: 'text-right',
          key: 'actions'
        }
      ]
    }
    if (this.isSmallScreen) {
      config.columns = [
        {
          minWidth: '110px',
          width: 14.28,
          key: 'name',
          searchKey: 'name',
          hasSort: true,
          hasSearch: true,
          label: 'Name',
          type: ETableColumnType.default
        },
        {
          minWidth: '125px',
          width: 14.28,
          key: 'address',
          searchKey: 'address',
          hasSort: true,
          hasSearch: true,
          label: 'Address',
          type: ETableColumnType.default
        },
        {
          minWidth: '110px',
          width: 14.28,
          key: 'city',
          searchKey: 'city',
          hasSort: true,
          hasSearch: true,
          label: 'City',
          type: ETableColumnType.default
        },
        {
          minWidth: '110px',
          width: 14.28,
          key: 'state',
          searchKey: 'state',
          hasSort: true,
          hasSearch: true,
          label: 'State',
          type: ETableColumnType.default
        },
        {
          minWidth: '60px',
          width: 14.28,
          key: 'zip',
          searchKey: 'zip',
          hasSort: true,
          hasSearch: true,
          label: 'Zip',
          type: ETableColumnType.default
        },
        {
          minWidth: '130px',
          width: 14.28,
          key: 'numberOfFacilities',
          searchKey: 'numberOfFacilities',
          hasSort: true,
          hasSearch: true,
          label: '# of Facilities',
          type: ETableColumnType.default
        },
        {
          minWidth: '30px',
          width: 14.28,
          class: 'text-right',
          key: 'actions'
        }
      ]
    }
    return config
  }

  get isSmallScreen (): boolean {
    return this.windowWidth < 1400
  }

  get hmos () {
    return this.$store.state.hmo.hmos
  }

  get hmosUserHasAccessTo () {
    return this.userIsAllFacilities
      ? this.hmos
      : this.hmos.filter((hmo: IHmo) =>
        hmo.isAllFacilities ||
        hmo.facilities.find(
          (hmoFacilityId: number) =>
            this.usersFacilities.includes(Number(hmoFacilityId))
        )
      )
  }

  get hmosCount () {
    return this.$store.state.hmo.count
  }

  get facilities (): IFacility[] {
    return this.$store.state.facility.facilities
  }

  get usersFacilities (): number[] {
    return this.$store.state.user.user.facilities
  }

  get userIsAllFacilities () {
    return this.$store.state.user.user.isAllFacilities
  }

  userCanEditHMO (hmo: IHmo): boolean {
    if (this.userIsAllFacilities) {
      return true
    } else if (hmo.isAllFacilities) {
      return isSubset<number>(
        this.facilities.map(f => f.id as number),
        this.usersFacilities
      )
    } else { 
      return isSubset<number>(
        hmo.facilities.map(facilityId => +facilityId), 
        this.usersFacilities
      )
    }
  }

  setWW () {
    this.windowWidth = window.innerWidth
  }

  async mounted () {
    await this.facilityModuleInstance.getFacilityList({ isAllFacilities: true })
    window.addEventListener('resize', this.setWW)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.setWW)
  }

  openAddHmoModal (hmo: any) {
    this.hmoPreparedForEdit = hmo
    this.showAddHMOModal = true
  }

  closeAddHmoModal () {
    this.showAddHMOModal = false
    this.hmoPreparedForEdit = null
  }

  async editOrAddHmo () {
    this.showAddHMOModal = false
    // @ts-ignore
    await this.$refs.table.initSearch()
  }

  openDeleteHmoModal (id: number, name: string) {
    this.hmoPreparedForDeletion = id
    this.hmoPreparedForDeletionName = name
    this.showDeleteHmoModal = true
  }

  closeDeleteHmoModal () {
    this.hmoPreparedForDeletion = null
    this.hmoPreparedForDeletionName = ''
    this.showDeleteHmoModal = false
  }

  async deleteHMO () {
    if (this.hmoPreparedForDeletion !== null) {
      const res = this.userIsAllFacilities
        ? await this.hmoModuleInstance.deleteHmo(this.hmoPreparedForDeletion)
        : await this.removeUserFacilitiesFromHMO()
      if (res === 'OK') {
        this.closeDeleteHmoModal()
        // @ts-ignore
        await this.$refs.table.initSearch()
      } else {
        this.showDeleteHmoModal = false
        this.showCantDeleteHmoModal = true
      }
    }
  }

  removeUserFacilitiesFromHMO () {
    const hmoForEdit: IHmo = this.hmos.find((hmo: IHmo) =>
      this.hmoPreparedForDeletion === hmo.id
    )
    const hmoFacilities = (
      hmoForEdit.isAllFacilities
        ? this.facilities.map(facility => facility.id)
        : hmoForEdit.facilities
    ) as number[]
    const updatedFacilities = hmoFacilities.filter(facility =>
      !this.usersFacilities.includes(Number(facility))
    )
    if (!updatedFacilities.length) {
      return this.hmoModuleInstance.deleteHmo(hmoForEdit.id)
    } else {
      return this.hmoModuleInstance.editHmo({
        ...hmoForEdit,
        facilities: updatedFacilities,
        isAllFacilities: false
      })
    }
  }

  facilitiesAddedToHmo (facilities: []): any[] {
    return this.facilities.filter((facility: any) =>
      !!facilities.find((facilityId: any) => Number(facility.id) === Number(facilityId)))
  }
}
